import { Injectable } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Observable } from 'rxjs';
import { GreencoinActivity } from '@shared/interfaces/greencoin-activity.interface';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class GreencoinActivityService {
    constructor(private baseHttp: BaseHttpService) {
    }

    getProjectActivity(projectId: number): Observable<GreencoinActivity> {
        return this.baseHttp
            .get('/xhr/check-activity-coins/project/' + projectId)
            .pipe(
                map((resp) => resp as GreencoinActivity)
            )
    }
}
